import { useEffect } from 'react';

export default function (...requests) {
  useEffect(() => {
    (async function() {
      requests.forEach(({condition, action}) => {
        condition && action();
      })
    })()
  }, []);
}